export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/muze-bg.png?a30d6d596e75337df8c462fcae4dde10";